<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CRow>
            <CCol lg="3">
              <CInput
                disabled
                label="Partnership Code"
                v-model="items.partnership_code"
              />
            </CCol>
            <CCol lg="3">
              <CInput disabled label="User Code" v-model="items.user_code" />
            </CCol>

             <CCol lg="3">
              <CInput disabled label="User Name" v-model="items.user_name" />
            </CCol>
            
            
          </CRow>
          

          <CRow>
            <CCol lg="3">
              <!-- <CInput disabled label="Status" v-model="items.status" /> -->
              <div class="form-group">
                <label for="status">Status</label>
                <model-select
                  class="form-control"
                  id="status"
                  :options="statusList"
                  v-model="$v.partnerForm.status.$model"
                  :isError="$v.partnerForm.status.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.partnerForm.status.$invalid"
                  class="invalid-feedback-custom"
                >
                  Status should be filled.
                </div>
              </div>
            </CCol>

          </CRow>
          <CRow>
              <CCol lg="3">
              <CInput
                disabled
                label="Approved Time"
                v-model="items.approved_time"
              />
            </CCol>

            <CCol lg="3">
              <CInput
                disabled
                label="Approved by"
                v-model="items.approved_by"
              />
            </CCol>
           
          </CRow>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              color="success"
              title="Detail"
              :disabled="$v.partnerForm.$invalid"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab>
            <template slot="title">User Document</template>
            <br />
            <UserDocument v-if="partnerForm.partnership_code" :dc_items="partnerForm" :is-loading="isLoading"></UserDocument>
          </CTab>
          <CTab>
            <template slot="title">Questionnaire</template>
            <br />
            <Questionnaire
              :items="qa_items"
              :is-loading="isLoading"
            ></Questionnaire>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "@/templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import { required } from "vuelidate/lib/validators";
import UserDocument from "./tabs/UserDocument";
import Questionnaire from "./tabs/Questionnaire";


export default {
  name: "PartnershipFormDetail",
  components: {
    GlobalTable,
    Loading,
    UserDocument,
    Questionnaire,

  },
  data() {
    return {
      title: "Partnership Form",
      partnerForm: tableInterfaces.partnership,
      items: [],
      qa_items: [],
      isLoading: false,
      activeTab: 0,
      unixTime: Math.floor(Math.random() * (0 - 9999999999 + 1)) + 0,
      showImages: "",
      preview: false,
      statusList: [   
        { value: "1", text: "Approved" },
        { value: "2", text: "Rejected" },
        ],
    };
  },
  validations: {
    partnerForm: {
      status: { },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (id) {
      this.getDetailPartnership(id);
    },
    back: function () {
      this.$router.go(-1);
    },
    getDetailPartnership: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/partnership/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.partnerForm = response.data.data;
            this.axios
              .get(
                "console/partnership/questioner/" +
                  response.data.data.partnership_code
              )
              .then((response) => {
                if (response.data.status === 2000) {
                  this.qa_items = response.data.data;

                  this.showInfoNotification({
                    title: this.title,
                    message: response.data.message,
                  });
                } else {
                  this.showErrorNotification({
                    title: this.title,
                    message: response.data.message,
                  });
                }
              });

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    previewImages: function (img) {
      this.showImages = "";
      this.preview = true;
      this.showImages = img;
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.partnerForm.partnership_code = this.items.partnership_code;
        this.partnerForm.id = this.items.id;
        this.axios
          .post("console/partnership/process-request", this.partnerForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Partnership Form Update Status",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Partnership Form Update Status");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
